export const breakPoints = {
  sm: 480,
  md: 640,
  lg: 990
};



// WEBPACK FOOTER //
// ./src/config/breakpoints.js